import React from "react";
import ReplayIcon from "@mui/icons-material/Replay";

export const ButtonRandom = ({ onClick }) => {
  return (
    <div>
      <button
        onClick={onClick}
        className="btn-random"
        style={{ display: "flex", alignItems: "center", color: "white" }}
      >
        {" "}
        <ReplayIcon size=".5rem" />
      </button>
    </div>
  );
};

export default ButtonRandom;
